import { useAuthStore } from '@/stores/auth';

// The guard both layouts share. It is NOT a `beforeLoad` redirect: `initialize()` resolves the
// Supabase session asynchronously, and beforeLoad would fire against the persisted-but-unverified
// flag before that lands. Render nothing until it settles — a flash of the shell for a signed-out
// user is worse than a blank frame.
export function RequireAuth({ children }: { children: React.ReactNode }): React.ReactNode {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) return null;
  if (!isAuthenticated) {
    window.location.replace('/login');
    return null;
  }
  return children;
}
